import { useEffect, useState } from "react";
import { useGetPageQuery, useLazyGetPageQuery } from "../../../redux/services/crmAPI";
import DatePicker from "react-date-picker";
import moment from "moment/moment";
import Select from "react-select";

import "./reportsOrder.scss";
import { Link } from "react-router-dom";

const ReportsOrder = () => {
    const [total, setTotal] = useState(0);
    const [fromDate, setFromDate] = useState(new Date());
    const [startDateSearchValue, setStartDateSearchValue] = useState("");
    const [toDate, setToDate] = useState(new Date());
    const [endDateSearchValue, setEndDateSearchValue] = useState("");

    const [selectStoreList, setSelectStoreList] = useState([]);
    const [selectShippersList, setSelectShippersList] = useState([]);
    const [selectCategoriesList, setSelectselectCategoriesList] = useState([]);

    const [store, setStore] = useState([]);
    const [shipper, setShipper] = useState([]);
    const [category, setCategory] = useState([]);

    const startDateParams = "&start_date=" + startDateSearchValue;
    const endDateParams = "&end_date=" + endDateSearchValue;
    const storeParams = store.join("");
    const shipperParams = shipper.join("");
    const categoryParams = category.join("");

    const paramsCombainer = startDateParams + endDateParams;

    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const { data: shippers } = useGetPageQuery("shippers?&per_page=100&active=1");
    const { data: categorySelect } = useGetPageQuery("categories/select");
    const [triggerRepotFetch, result] = useLazyGetPageQuery();

    const onStoreSelectHandler = (selected) => {
        setStore([...selected.map((store) => `&store_ids[]=` + store.value)]);
    };

    const onShipperSelectHandler = (selected) => {
        setShipper([...selected.map((shipper) => "&shipper_ids[]=" + shipper.value)]);
    };

    const onCategorySelectHandler = (selected) => {
        setCategory([...selected.map((category) => "&category_ids[]=" + category.value)]);
    };

    useEffect(() => {
        setStartDateSearchValue(moment(fromDate).format("DD.MM.YYYY"));
        setEndDateSearchValue(moment(toDate).format("DD.MM.YYYY"));
    }, [fromDate, toDate]);

    const fetchReportsHandler = async () => {
        await triggerRepotFetch("report/orders?" + paramsCombainer + storeParams + shipperParams + categoryParams);
    };

    const calculateTotalPrice = (reports) => {
        let totalPrice = 0;

        reports.forEach((report) => {
            report.products.forEach((product) => {
                totalPrice += product.prices.price * product.prices.quantity;
            });
            report.services.forEach((service) => {
                totalPrice += service.prices.price * service.prices.quantity;
            });
        });
        return totalPrice;
    };

    const calculateProfit = (reports) => {
        let totalPrice = 0;

        reports.forEach((report) => {
            report.products.forEach((product) => {
                totalPrice += (product.prices.price - product.price_stock) * product.prices.quantity;
            });
            report.services.forEach((service) => {
                totalPrice += service.prices.price * service.prices.quantity;
            });
        });
        return totalPrice;
    };

    const calculateCurrentProfit = (report) => {
        let totalPrice = 0;

        report.products.forEach((product) => {
            totalPrice += (product.prices.price - product.price_stock) * product.prices.quantity;
        });
        report.services.forEach((service) => {
            totalPrice += service.prices.price * service.prices.quantity;
        });

        return totalPrice;
    };

    const calculateTerminalProfit = (reports) => {
        let totalPrice = 0;
        const teminalRepots = reports.filter((report) => report.is_terminal);

        teminalRepots.forEach((report) => {
            report.products.forEach((product) => {
                totalPrice += (product.prices.price - product.price_stock) * product.prices.quantity;
            });
        });

        return totalPrice;
    };

    const calculateCardProfit = (reports) => {
        let totalPrice = 0;
        const cardRepots = reports.filter((report) => report.is_card);

        cardRepots.forEach((report) => {
            report.products.forEach((product) => {
                totalPrice += product.prices.price - product.price_stock * product.prices.quantity;
            });
        });

        return totalPrice;
    };

    useEffect(() => {
        if (stores) {
            setSelectStoreList([
                ...stores.data.map((store) => {
                    return { value: store.id, label: store.title };
                }),
            ]);
        }
        if (shippers) {
            setSelectShippersList([
                ...shippers.data.map((shipper) => {
                    return { value: shipper.id, label: shipper.title_short };
                }),
            ]);
        }
        if (categorySelect) {
            setSelectselectCategoriesList([
                ...categorySelect.map((category) => {
                    return {
                        value: category.id,
                        label: "\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(category.level) + category.title,
                    };
                }),
            ]);
        }
    }, [stores, shippers, categorySelect]);

    const reports = result.data;

    return (
        <>
            {stores && categorySelect && shippers && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header" className="no-print">
                            <h1>Звіт по продажам</h1>
                        </div>
                        <div className="no-print">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header">Виберіть продавця (касу)</div>
                                        <div className="card-body">
                                            <div className="mt-3">
                                                <label className="d-block">Категорії</label>
                                                <Select
                                                    options={selectCategoriesList}
                                                    placeholder={"Категорія"}
                                                    isMulti
                                                    onChange={onCategorySelectHandler}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <label className="d-block">Постачальники</label>
                                                <Select
                                                    options={selectShippersList}
                                                    placeholder={"Постачальник"}
                                                    isMulti
                                                    onChange={onShipperSelectHandler}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <label className="d-block">Магазини</label>
                                                <Select
                                                    options={selectStoreList}
                                                    placeholder={"Магазини"}
                                                    isMulti
                                                    onChange={onStoreSelectHandler}
                                                />
                                            </div>
                                            <button
                                                value="Створити звіт"
                                                className="btn btn-primary"
                                                style={{ marginTop: "12px" }}
                                                onClick={() => fetchReportsHandler()}
                                            >
                                                Створити звіт
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-6">
                                    <div className="card card-default">
                                        <div className="card-header">Виберіть дату</div>
                                        <div className="card-body datas">
                                            <div className="input-group">
                                                <span className="input-group-prepend" id="date_from">
                                                    <span className="input-group-text">Від</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setFromDate}
                                                    value={fromDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                            <div className="input-group">
                                                {" "}
                                                <span className="input-group-prepend" id="date_to">
                                                    <span className="input-group-text">До</span>
                                                </span>
                                                <DatePicker
                                                    onChange={setToDate}
                                                    value={toDate}
                                                    format="dd.MM.yyyy"
                                                    locale="uk-UA"
                                                    className="custom-input"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        {reports && (
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-default">
                                        <div className="card-header">
                                            Продажі з {startDateSearchValue} по {endDateSearchValue}
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-striped table-print">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="id">ID</th>
                                                            <th data-field="user_status">Товари</th>
                                                            <th data-field="user_status" className="no-mobile">
                                                                Ціна
                                                            </th>
                                                            <th data-field="user_status" className="no-mobile">
                                                                Закупка
                                                            </th>
                                                            <th data-field="user_status" className="no-mobile">
                                                                Прибуток
                                                            </th>
                                                            <th data-field="user_status" className="no-mobile">
                                                                Сума
                                                            </th>
                                                            <th data-field="user_status">Прибуток</th>
                                                            <th data-field="user_status" className="no-mobile">
                                                                Дата
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reports.map((report) => {
                                                            return (
                                                                <tr key={report.id}>
                                                                    <td>
                                                                        <Link to={"/order/" + report.id}>
                                                                            #{report.id}
                                                                        </Link>
                                                                        <span
                                                                            className="icon icon-novaposhta"
                                                                            title="Відправка новою поштою"
                                                                            alt="Відправка новою поштою"
                                                                        ></span>{" "}
                                                                    </td>
                                                                    <td>
                                                                        <ul className="list_purchaches">
                                                                            {report.products.map((product) => {
                                                                                return (
                                                                                    <li key={product.id}>
                                                                                        {product.prices.quantity}x{" "}
                                                                                        <Link
                                                                                            to={
                                                                                                "/product/" + product.id
                                                                                            }
                                                                                        >
                                                                                            {product.title} (
                                                                                            {product.imei_sn.slice(
                                                                                                product.imei_sn.length -
                                                                                                    5
                                                                                            )}
                                                                                            )
                                                                                        </Link>
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                            {report.services.map((service) => {
                                                                                return (
                                                                                    <li key={service.id}>
                                                                                        {service.prices.quantity}x{" "}
                                                                                        <Link
                                                                                            to={
                                                                                                "/service/" + service.id
                                                                                            }
                                                                                        >
                                                                                            {service.title}
                                                                                        </Link>
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        <ul className="list_purchaches">
                                                                            {report.products.map((product) => {
                                                                                return (
                                                                                    <li key={product.id}>
                                                                                        {product.prices.price}
                                                                                        &nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                            {report.services.map((service) => {
                                                                                return (
                                                                                    <li key={service.id}>
                                                                                        {service.prices.price}
                                                                                        &nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        <ul className="list_purchaches">
                                                                            {report.products.map((product) => {
                                                                                return (
                                                                                    <li key={product.id}>
                                                                                        {product.price_stock}
                                                                                        &nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                            {report.services.map((service) => {
                                                                                return (
                                                                                    <li key={service.id}>
                                                                                        00.00&nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        <ul className="list_purchaches">
                                                                            {report.products.map((product) => {
                                                                                return (
                                                                                    <li key={product.id}>
                                                                                        {product.prices.price -
                                                                                            product.price_stock}
                                                                                        &nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                            {report.services.map((service) => {
                                                                                return (
                                                                                    <li key={service.id}>
                                                                                        00.00&nbsp;грн.
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    </td>

                                                                    <td className="no-mobile">
                                                                        {report.products.reduce(
                                                                            (totalPrice, procut) => {
                                                                                return (totalPrice +=
                                                                                    procut.prices.price *
                                                                                    procut.prices.quantity);
                                                                            },
                                                                            0
                                                                        ) +
                                                                            report.services.reduce(
                                                                                (totalPrice, service) => {
                                                                                    return (totalPrice +=
                                                                                        service.prices.price *
                                                                                        service.prices.quantity);
                                                                                },
                                                                                0
                                                                            )}
                                                                        &nbsp;грн.
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-success">
                                                                            {calculateCurrentProfit(report)}
                                                                            {/* {report.products.reduce(
                                                                                (totalPrice, product) => {
                                                                                    return (totalPrice +=
                                                                                        product.prices.price -
                                                                                        product.price_stock);
                                                                                },
                                                                                0
                                                                            )} */}
                                                                            &nbsp;грн.
                                                                        </span>
                                                                    </td>
                                                                    <td className="no-mobile">
                                                                        {moment(report.created_at).format(
                                                                            "DD.MM.YYYY hh:MM"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="all_price_of_day">
                                                Всього: <b>{calculateTotalPrice(reports)}0&nbsp;грн.</b>
                                            </div>
                                            <div className="all_price_of_day">
                                                Термінал: <b>{calculateTerminalProfit(reports)}&nbsp;грн.</b>
                                            </div>
                                            <div className="all_price_of_day">
                                                На карту: <b>{calculateCardProfit(reports)}&nbsp;грн.</b>
                                            </div>
                                            <div className="all_price_of_day red">
                                                Прибуток: <b>{calculateProfit(reports)}&nbsp;грн.</b>
                                            </div>
                                            {/* <div className="all_price_of_day">10.25</div> */}
                                        </div>
                                    </div>
                                    <div className="no-print">
                                        <button
                                            className="btn btn-primary pull-right no-print"
                                            value="Друк"
                                            onClick={() => window.print()}
                                        >
                                            Друк звіту
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReportsOrder;
